import { useState } from "react";

export function useAccordion(defaultOpen = false) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  
  return { isOpen, setIsOpen };
}
